<template>
  <div class="detail">
    <!-- 分类 -->
    <div class="left-menus" id="menus">
      <div style="padding: 15px 17px 5px 17px;">
        <el-input v-model="search" placeholder="请输入搜索内容..." size="medium" clearable>
          <el-button slot="prepend" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <el-menu ref="menuRef" active-text-color="#303133" :default-active="menuIndex" @select="selectMenu">
        <el-menu-item index="0" id="menu0" v-if="detail.cover">
          <span slot="title" class="m-title" :style="menuIndex == '0' ? 'color: #409EFF' : ''">封面</span>
        </el-menu-item>
        <el-menu-item index="-1" id="menu-1" v-if="detail.change">
          <span slot="title" class="m-title" :style="menuIndex == '-1' ? 'color: #409EFF' : ''">更改记录</span>
        </el-menu-item>
        <el-menu-item index="-3" id="menu-3" v-if="detail.catalogue">
          <span slot="title" class="m-title" :style="menuIndex == '-3' ? 'color: #409EFF' : ''">目录</span>
        </el-menu-item>
        <el-menu-item index="-2" id="menu-2" v-if="detail.explain">
          <span slot="title" class="m-title" :style="menuIndex == '-2' ? 'color: #409EFF' : ''">其他说明</span>
        </el-menu-item>
        <el-submenu v-for="(item, index) in searchClassifyList" :key="index" :index="`${item.id}`"
          :id="`menu${item.id}`">
          <span slot="title" class="m-title">{{ item.name }}</span>
          <template v-if="item.classifies && item.classifies.length > 0">
            <el-menu-item v-for="(child, idx) in item.classifies" :key="idx" :index="`${child.id}`"
              :id="`menu${child.id}`">
              <span slot="title" :style="menuIndex == child.id ? 'color: #409EFF' : ''">
                {{ child.name }}
              </span>
            </el-menu-item>
          </template>
        </el-submenu>
      </el-menu>
    </div>
    <!-- 具体内容 -->
    <div class="right-content" id="right-content" @contextmenu.prevent @dragstart.prevent @mousewheel="stopScroll"
      @mouseenter="stopScroll" @scroll="onScroll">
      <div v-if="detail.cover" class="imgs" id="img0">
        <el-image class="img" :src="detail.cover" lazy fit="cover"></el-image>
      </div>
      <div v-if="detail.change" class="imgs" id="img-1">
        <el-image class="img" :src="detail.change" lazy fit="cover"></el-image>
      </div>
      <div v-if="detail.catalogue" class="imgs" id="img-3">
        <el-image class="img" :src="detail.catalogue" lazy fit="cover"></el-image>
      </div>
      <div v-if="detail.explain" class="imgs" id="img-2">
        <el-image class="img" :src="detail.explain" lazy fit="cover"></el-image>
      </div>
      <template v-if="classifyList && classifyList.length > 0">
        <template v-for="(item, index) in classifyList">
          <div v-for="(child, idx) in item.classifies" class="imgs" :id="`img${child.id}`">
            <el-image v-for="(img, i) in child.imgs" :key="img" class="img" :src="img" lazy fit="cover" :preview-src-list="[img]">
            </el-image>
            <!-- <template v-for="(img, i) in child.imgs">
              <el-image v-if="!isMagnifier" :key="img" class="img" :src="img" lazy fit="cover"></el-image>
              <vab-magnifier v-else type="circle" :url="img" class="img" :width="250"></vab-magnifier>
            </template> -->
          </div>
        </template>
      </template>
      <div v-else class="empty">
        <i class="icon el-icon-receiving"></i>
        <span class="tip">暂无内容</span>
      </div>
    </div>

    <!-- <el-tooltip effect="dark" content="放大镜" placement="top">
      <div class="magnifying-glass" @click="isMagnifier = !isMagnifier">
        <i class="el-icon-search" style="font-size: 18px;"></i>
      </div>
    </el-tooltip> -->

    <Watermark v-if="watermarkContent" :content="watermarkContent" :zIndex="99999"></Watermark>
  </div>
</template>

<script>
  // import VabMagnifier from 'vab-magnifier';
  // import 'vab-magnifier/lib/vab-magnifier.css'

  import {
    getUser
  } from '@/utils/auth'

  import {
    getOfferBookDetail
  } from '@/api/quotation'

  import Watermark from '@/components/Watermark'

  export default {
    name: 'quotation-detail',
    components: {
      Watermark,
      // VabMagnifier
    },
    data() {
      return {
        tempRoute: {},
        watermarkContent: '',

        menuIndex: '0',

        interval: null,
        intervalCount: 0,

        search: '',
        loading: false,
        detail: {},
        classifyList: [],

        isMagnifier: false,
      }
    },
    computed: {
      user: getUser,
      searchClassifyList() {
        let list = [];
        if (this.search) {
          this.classifyList.forEach(r => {
            let new_child = []
            if (r.classifies && r.classifies.length > 0) {
              r.classifies.forEach(c => {
                if (c.name && c.name.indexOf(this.search) > -1) {
                  new_child.push({
                    ...c
                  });
                }
              });
            }
            if (new_child.length > 0) {
              list.push({
                ...r,
                classifies: new_child
              });
              // if (this.$refs.menuRef) {
              //   this.$refs.menuRef.open(`${r.id}`);
              // }
            }
          });
        } else {
          list = [...this.classifyList];
        }
        return list;
      },
    },
    created() {
      this.tempRoute = Object.assign({}, this.$route)
      this.getData()
      this.$nextTick(() => {
        this.watermarkContent = (this.user.dUserid || this.user.userid) + ' ' + (this.user.dName || this.user.name);
      })
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      })
    },
    methods: {
      selectMenu(index, path) {
        this.menuIndex = index;

        this.stopScroll()
        // 跳转对应图片位置
        const anchor = document.getElementById('img' + index);
        if (anchor) {
          anchor.scrollIntoView({
            behavior: 'auto'
          });
          this.interval = setInterval(() => {
            anchor.scrollIntoView({
              behavior: 'auto'
            });
            this.intervalCount += 1;
            if (this.intervalCount >= 30) {
              this.stopScroll()
            }
          }, 100);
        }
      },

      onScroll(event) {
        if (this.interval) return;
        // console.log(event)
        const container = event.target; // 获取触发事件的元素，即滚动容器
        const scrollTop = container.scrollTop; // 获取当前滚动位置
        const clientHeight = container.clientHeight; // 获取容器可视区域的高度
        const scrollHeight = container.scrollHeight; // 获取容器内容总高度
        const visibleItems = []; // 存储当前可视的元素数组
        const items = container.children || [];

        // 遍历所有元素，检查它们是否在当前视窗内
        for (let i = 0; i < items.length; i++) {
          const itemElement = items[i];
          const itemTop = itemElement.offsetTop; // 获取元素顶部位置
          const itemHeight = itemElement.offsetHeight; // 获取元素高度
          if (itemTop + itemHeight >= scrollTop + 2 && itemTop <= scrollTop + clientHeight - 2) {
            // console.log(itemTop, itemHeight, scrollTop, clientHeight)
            visibleItems.push(itemElement.id); // 如果元素在视窗内，加入到数组中
          }
        }

        if (visibleItems.length > 0) {
          // console.log(visibleItems)
          const id_str = visibleItems[0];
          const menuIndex = id_str.replace('img', '');

          if (this.menuIndex != menuIndex) {
            // console.log(this.menuIndex, menuIndex)
            this.menuIndex = menuIndex;

            this.scrollToMenu();
            setTimeout(() => {
              this.scrollToMenu();
            }, 250);
          }
        }
      },

      // 菜单滚动至当前选择
      scrollToMenu() {
        const element = document.getElementById('menus');
        if (element) {
          const liElements = element.getElementsByTagName('li');
          for (let i = 0; i < liElements.length; i++) {
            const itemElement = liElements[i];
            if (itemElement.id == ('menu' + this.menuIndex)) {
              const itemRect = itemElement.getBoundingClientRect();
              // console.log(itemRect)
              element.scrollTop = element.scrollTop + itemRect.y - 135;
              break;
            }
          }
        }
      },

      stopScroll() {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
      },

      deafultMenuIndex() {
        if (this.detail && this.detail.id) {
          if (this.detail.cover) return '0';
          if (this.detail.cover) return '1';
          if (this.detail.explain) return '-2';
          if (this.detail.catalogue) return '-3';
          if (this.classifyList && this.classifyList.length > 0) {
            const item = this.classifyList[0];
            if (item && item.classifies && item.classifies.length > 0) {
              return `${item.classifies[0].id}`;
            }
          }
        }
        return '0';
      },

      numberToChinese(num) {
        const arr = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十");
        let result = num + '';
        if (num <= 10) {
          result = arr[num];
        }
        return result;
      },

      getData() {
        this.loading = true
        getOfferBookDetail({
          userId: this.user.dUserid || this.user.userid,
          groupId: this.user.dGroupid,
          dealerId: this.user.delid
        }).then(response => {
          // console.log(response)
          this.loading = false
          this.detail = response.data || {}
          this.classifyList = this.detail.classifies || []

          let preloadImages = [];
          this.classifyList.forEach((r, i) => {
            r.name = this.numberToChinese(i + 1) + '、' + r.name;
            if (r.classifies && r.classifies.length > 0) {
              r.classifies.forEach((c, ci) => {
                c.name = (i + 1) + '.' + (ci + 1) + ' ' + c.name;
                c.imgs = c.imgs ? c.imgs.split(',') : [];
                preloadImages.push(...c.imgs);
              });
            } else {
              r.classifies = [];
            }
          });

          // 图片预加载
          if (preloadImages.length > 0) {
            const halfIndex = Math.ceil(preloadImages.length / 2);
            const frontImgs = preloadImages.slice(0, halfIndex);
            const backImgs = preloadImages.slice(halfIndex);

            this.loadImagesWithLimit(frontImgs, 5);
            setTimeout(() => {
              this.loadImagesWithLimit(backImgs.reverse(), 5);
            }, 5000);
          }

          this.menuIndex = this.deafultMenuIndex()

          const pageTitle = `查看报价书${this.detail.name ? '-' + this.detail.name : ''}`
          document.title = pageTitle
          const route = Object.assign({}, this.tempRoute, {
            title: pageTitle
          })
          this.$store.dispatch('tagsView/updateVisitedView', route)
        }).catch(() => {
          this.loading = false
        })
      },

      loadImagesWithLimit(srcList = [], limit = 3) {
        let index = 0;
        const results = [];

        const loadNextBatch = () => {
          if (index >= srcList.length) return Promise.resolve(results);

          const batch = [];
          for (let i = 0; i < limit && index < srcList.length; i++) {
            const src = srcList[index++];
            const res = this.loadImage(src).then((img) => results.push(img));
            batch.push(res);
          }

          return Promise.all(batch).then(loadNextBatch);
        }

        return loadNextBatch();
      },

      loadImage(src){
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = () => reject(new Error(`Failed to load image at ${src}`));
          img.src = src;
        });
      },

    }
  }
</script>

<style lang="scss" scoped>
  .detail {
    position: relative;
    height: calc(100vh - 84px);
    display: flex;

    ::v-deep .el-input-group__prepend {
      padding: 0 14px !important;
    }

    ::v-deep .vab-magnifier img {
      display: block !important;
    }
  }

  .left-menus {
    width: 240px;
    min-width: 240px;
    height: 100%;
    background: #ffffff;
    border: 1px solid #e6e6e6;
    overflow-y: auto;

    .m-title {
      font-weight: bold;
    }
  }

  .right-content {
    flex: 1;
    height: 100%;
    overflow-y: auto;
  }

  .imgs {
    width: 100%;
    min-height: 20vh;
    display: flex;
    flex-direction: column;

    .imgs-classify {
      width: 100%;
      height: 100%;
    }

    .img {
      flex: 1;
      height: auto;
      user-select: none;
    }
  }

  .empty {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .icon {
      font-size: 100px;
      color: #dcdfe6;
    }

    .tip {
      padding: 15px 0;
      font-size: 14px;
      color: #909399;
    }
  }

  .magnifying-glass {
    width: 35px;
    height: 35px;
    position: fixed;
    bottom: 100px;
    right: 40px;
    z-index: 99999;
    background-color: #ffffff;
    border-radius: 50%;
    border: 2px solid #e6e6e6;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
</style>
